import axios from "axios";

const api = axios.create({
  baseURL: "https://sribrahmam.in/sri_brahmam/public/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;